module.exports = __webpack_public_path__ + "img/jf-btn.3bb0b82f.png";